import { useEffect, useState } from "react";
import { TOPICS } from "../data/constants";
import { fetchTopicsMerged } from "../lib/api";

// Loads topics from backend once at mount, merging with local defaults.
// `fetchTopicsMerged` is module-level (stable) — no hook-deps needed.
export function useTopicsData() {
  const [topics, setTopics] = useState(TOPICS);
  useEffect(() => {
    let cancelled = false;
    fetchTopicsMerged()
      .then((merged) => {
        if (!cancelled && merged) setTopics(merged);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return topics;
}
